module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADpSURBVHgBtZOxDcIwEEUPSA0dDWQCWCBMwABRFoAJoKOjR2KAwAKBIejo6CIGAAYgC8A/uES2ZUdOkS89Kcp9n+98NlEL6oMTeBnsJaapY1m8BhE4GLEluIIUPG0JQnAGb1CAh5FgAgbgAxYg55+BYjiCnWTncjMjwUyJb0FsVsB9juQ7kTZUZdKC6dUS+KryBjWmFZjS/2BjapJVxGcy9vRaf5ZTsc2/8nbJLR4nl84jjVymujPgC8Ut8KRy8tCdLFfVolC8P/WUwBDMZbfCsZg32IAbuBDpF6l8Bwm5K+HE/EZScm/STF80nC8rJK+eCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/englishVoice/icon_check_sentence.png
// module id = RTRZ
// module chunks = 4